var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMedicalEvaluationIcon = function SvgMedicalEvaluationIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 41,
    viewBox: "0 0 54 41",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1700",
    "data-name": "Ret\\xE2ngulo 1700",
    width: 45.352,
    height: 40.65,
    transform: "translate(0 0)",
    fill: "#1f35b5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5912",
    "data-name": "Grupo 5912",
    transform: "translate(-457 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5911",
    "data-name": "Grupo 5911",
    transform: "translate(465 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4401",
    "data-name": "Caminho 4401",
    d: "M26.6,28.35V32.2h3.85L41.3,21.35l-3.85-3.85Z",
    fill: "#1f35b5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5744",
    "data-name": "Grupo 5744"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5743",
    "data-name": "Grupo 5743",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4402",
    "data-name": "Caminho 4402",
    d: "M44.9,15.35,43.452,13.9a1.824,1.824,0,0,0-2.4,0L39.6,15.35l3.849,3.85L44.9,17.75a1.825,1.825,0,0,0,0-2.4",
    fill: "#1f35b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1697",
    "data-name": "Ret\\xE2ngulo 1697",
    width: 19.8,
    height: 3,
    transform: "translate(8.4 20.8)",
    fill: "#1f35b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1698",
    "data-name": "Ret\\xE2ngulo 1698",
    width: 19.8,
    height: 3,
    transform: "translate(8.4 12.45)",
    fill: "#1f35b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1699",
    "data-name": "Ret\\xE2ngulo 1699",
    width: 13.55,
    height: 3,
    transform: "translate(8.4 29.2)",
    fill: "#1f35b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4403",
    "data-name": "Caminho 4403",
    d: "M33.2,37.2H3.4V7.45H33.2V17.51l2.131-2.131.029-.029,1.24-1.24V7.45a3.355,3.355,0,0,0-1-2.425A3.236,3.236,0,0,0,33.2,4H23.25a4.828,4.828,0,0,0-1.725-2.875,5.185,5.185,0,0,0-6.45,0A4.828,4.828,0,0,0,13.35,4H3.4A3.236,3.236,0,0,0,1,5.025,3.355,3.355,0,0,0,0,7.45V37.2a3.33,3.33,0,0,0,1,2.45,3.273,3.273,0,0,0,2.4,1H33.2a3.273,3.273,0,0,0,2.4-1,3.33,3.33,0,0,0,1-2.45V30.3l-3.4,3.4ZM17.025,3.45a1.753,1.753,0,0,1,2.55,0,1.82,1.82,0,0,1,.525,1.3A1.762,1.762,0,0,1,19.575,6a1.753,1.753,0,0,1-2.55,0A1.82,1.82,0,0,1,16.5,4.7a1.762,1.762,0,0,1,.525-1.25",
    fill: "#1f35b5"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1982",
    "data-name": "Ret\\xE2ngulo 1982",
    width: 54,
    height: 41,
    transform: "translate(457 188)",
    fill: "none"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMedicalEvaluationIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/medical-evaluation-icon.bb668061.svg";
export { ForwardRef as ReactComponent };